import { PropsWithChildren } from 'react';
import { Box, Button, Card, Stack, SxProps, Typography } from '@mui/material';
import { COLOR_ACCENT, COLOR_SECONDARY, Icons } from 'shared';

interface BackgroundCardProps extends PropsWithChildren {
  title?: string;
  onBack?: () => void;
  sx?: SxProps;
}

export const BackgroundCard = ({ children, title, onBack, sx }: BackgroundCardProps) => {
  return (
    <Card
      className="blur"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: { xs: 2, sm: 4 },
        pt: { xs: 2, sm: 3 },
        alignItems: 'center',
        width: { xs: '100%', sm: 505 },
        margin: '0 auto',
        minHeight: 677,
        ...sx,
      }}
    >
      {(onBack || title) && (
        <Stack
          direction="row"
          gap={{ xs: 1, sm: 5 }}
          justifyContent={onBack ? 'space-between' : 'center'}
          alignItems="center"
          width="100%"
          mb={2}
        >
          {onBack && (
            <Button
              variant="text"
              onClick={onBack}
              sx={{
                p: 1,
                minWidth: 0,
                minHeight: 0,
                '&:hover svg': { color: COLOR_ACCENT },
              }}
            >
              <Icons.ArrowChevron sx={{ rotate: '180deg', color: COLOR_SECONDARY }} />
            </Button>
          )}
          <Typography variant="h5" className="primary" noWrap>
            {title}
          </Typography>
          {onBack && <Box sx={{ width: 40 }} />}
        </Stack>
      )}

      {children}
    </Card>
  );
};
